/* eslint-disable */

import 'bootstrap-less/js/collapse';
import 'bootstrap-less/js/carousel';
import 'bootstrap-less/js/transition';

import './behavior';
